import React from 'react';

class Content extends React.Component {
  render() {
    const { userProfile, title } = this.props;
    const fullName = userProfile ? `${userProfile.family_name}, ${userProfile.given_name}` : '';

    return (
      <div className="Appbar navbar-default">
        <p className="text-center">
          <span className="title">{title}</span>
          <span className="sub-title"><b>FLS Window Planner</b> - {fullName}</span>
        </p>
      </div>
    )
  }
}

export default Content;